import { render, staticRenderFns } from "./Fumante.vue?vue&type=template&id=078a490e&scoped=true"
import script from "./Fumante.vue?vue&type=script&lang=js"
export * from "./Fumante.vue?vue&type=script&lang=js"
import style0 from "./Fumante.vue?vue&type=style&index=0&id=078a490e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a490e",
  null
  
)

export default component.exports